import React, { useState, useEffect } from "react";
import HeartToSoulImage from "../../../../Assets/Images/HeartToSoulImageOne.png";
import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import SoulIcon from "../../../../Assets/Images/SOUL.png";
import MindIcon from "../../../../Assets/Images/MIND.png";
import StrengthIcon from "../../../../Assets/Images/STRENGTH.png";
import flow_HM from '../../../../Assets/Images/flowScoreIcons/H-M.png'
import flow_HS from '../../../../Assets/Images/flowScoreIcons/H-S.png'
import flow_HST from '../../../../Assets/Images/flowScoreIcons/H-ST.png'
import flow_MH from '../../../../Assets/Images/flowScoreIcons/M-H.png'
import flow_MS from '../../../../Assets/Images/flowScoreIcons/M-S.png'
import flow_MST from '../../../../Assets/Images/flowScoreIcons/M-ST.png'
import flow_SH from '../../../../Assets/Images/flowScoreIcons/S-H.png'
import flow_SM from '../../../../Assets/Images/flowScoreIcons/S-M.png'
import flow_SST from '../../../../Assets/Images/flowScoreIcons/S-ST.png'
import flow_STH from '../../../../Assets/Images/flowScoreIcons/ST-H.png'
import flow_STM from '../../../../Assets/Images/flowScoreIcons/ST-M.png'
import flow_STS from '../../../../Assets/Images/flowScoreIcons/ST-S.png'
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import ArrowRight from '../../../../Assets/Images/left-arrow.png';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

function HeartToSoul({ apiData, pageNumber, reportType }) {

  const [highestStarter, setHighestStarter] = useState('')
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [snapshotResult, setSnapshotResults] = useState([])
  const [starterLabel, setStarterLabel] = useState([])

  const [variablsMapArray, setVariableMapArray] = useState()
  const [scoreRanking, setScoreRanking] = useState([])


  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" }
  ]

  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});
  useEffect(() => {
    if (variableMap) {
      setVariableMapArray(variableMap);
    }
    // console.log("apiData", apiData)
  }, [apiData]);

  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      // console.log(variablsMapArray);
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;

      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;

      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;

      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;

      // We'll set these values after calculating the results array below
      let strength_highest, heart_highest, soul_highest, mind_highest;

      // console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
      // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
      let testingVarsM2Pair = [{ "name": "heart", "score": heart_highest }, { "name": "soul", "score": soul_highest }, { "name": "mind", "score": mind_highest }, { "name": "strength", "score": strength_highest }];
      // console.log("testingVarsM2Pair", testingVarsM2Pair);

      highestVariable = testingVarsM2Pair.reduce((max, current) =>
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );


      let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m)
      let second_most_score = Math.max(heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m) / 2
      let least_score = Math.max(heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l)
      let second_least_score = Math.max(heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l) / 2


      let most_scored_label = "";
      const scoreMap = {
        Heart: heart_r1_m,
        Soul: soul_r1_m,
        Mind: mind_r1_m,
        Strength: strength_r1_m
      };

      most_scored_label = Object.keys(scoreMap).find(key => scoreMap[key] === most_score);

      // console.log("most_scored_label:", most_scored_label);

      // console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l", heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l)
      if (least_score >= second_least_score) {
        least_score = (second_least_score - 1)
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100

      // console.log("scores-", most_score, second_most_score, least_score, second_least_score)
      // console.log("scores-per", most_per, second_most_per, least_score, second_least_per)


      let labels = testingVarsM2Pair.map(item => item.name);

      const labels_arr = ["heart", "soul", "mind", "strength"];

      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      // console.log(most_label, 'most_label')
      const getPercentageOrder = (label) => {
        let value;
        if (label == most_label?.toLowerCase()) {
          value = most_per;
        } else if (label == second_most_label?.toLowerCase()) {
          value = second_most_per;
        } else if (label == least_label?.toLowerCase()) {
          value = least_per;
        } else if (label == second_least_label?.toLowerCase()) {
          value = second_least_per;
        } else {
          value = 0;
        }
        return typeof value === 'number' ? value : parseFloat(value);
      };

      // console.log("scores- starter", most_score, second_most_score, least_score, second_least_score)
      // console.log("scores-per-starter", most_per.toFixed(2), second_most_per.toFixed(2), least_score, second_least_per.toFixed(2))

      results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")]
      strength_highest = results[0];
      heart_highest = results[1];
      soul_highest = results[2];
      mind_highest = results[3];

      // labelsArray = [...labelsArray, ...labels];
      // labelsArray = [least_label, second_least_label, second_most_label, most_label];
      labelsArray = ['strength', 'heart', 'soul', 'mind'];

      // Using the dynamic pie chart results
      const RankedScores = [
        { name: "Strength", value: results[0] },
        { name: "Heart", value: results[1] },
        { name: "Soul", value: results[2] },
        { name: "Mind", value: results[3] }
      ];

      RankedScores.sort((a, b) => b.value - a.value);

      // console.log(RankedScores)

      setScoreRanking(applyFullTieOrder(RankedScores))

      // console.log('highestVariable', highestVariable)
      // console.log("pie chart results", results);
      // console.log("pie chart labelsArray", labelsArray);

      setHighestStarter(most_label);
      // setStarterScore(most_per);
      setSnapshotResults(results);
      setStarterLabel(labelsArray);
      getMostAndSecondMostVaribale(apiData)
    }

  }, [variablsMapArray]);

  const getMostAndSecondMostVaribale = () => {
    if (apiData?.variables?.length > 0) {
      const extractCoreVariable = (variable) =>
        variable?.split("_")[0];

      // If all four counts in a round tie, read that round in clockwise order (Strength, Heart, Soul, Mind)
      const getRoundVariables = (round) => applyFullTieOrder(
        pairs
          ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.[round]))
          ?.filter(Boolean),
        (v) => extractCoreVariable(v?.variable),
        (v) => v?.score
      );

      const highestRound1Variable = getRoundVariables("round1")
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const highestRound2Variable = getRoundVariables("round2")
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const coreRound1 = extractCoreVariable(highestRound1Variable?.variable);
      const coreRound2 = extractCoreVariable(highestRound2Variable?.variable);

      if (coreRound1 === coreRound2) {
        const secondHighestRound1Variable = getRoundVariables("round1")
          ?.sort((a, b) => b?.score - a?.score)
          ?.find((v) => v?.variable !== highestRound1Variable?.variable);

        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(secondHighestRound1Variable?.variable || null);
      } else {
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(highestRound2Variable?.variable || null);
      }
    }
  }

  const getFlowImage = () => {
    const images = {
      HS: flow_HS,
      HM: flow_HM,
      HST: flow_HST,
      MH: flow_MH,
      MS: flow_MS,
      MST: flow_MST,
      SH: flow_SH,
      SM: flow_SM,
      SST: flow_SST,
      STH: flow_STH,
      STM: flow_STM,
      STS: flow_STS,
    };
    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    return images[key?.toUpperCase()] || HeartToSoul;
  };

  const getFlowHead = () => {
    const flowMapping = {
      HS: "HEART TO SOUL",
      HM: "HEART TO MIND",
      HST: "HEART TO STRENGTH",
      MH: "MIND TO HEART",
      MS: "MIND TO SOUL",
      MST: "MIND TO STRENGTH",
      SH: "SOUL TO HEART",
      SM: "SOUL TO MIND",
      SST: "SOUL TO STRENGTH",
      STH: "STRENGTH TO HEART",
      STM: "STRENGTH TO MIND",
      STS: "STRENGTH TO SOUL",
    };


    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    const flowText = flowMapping[key] || "";
    return flowText;
  };

  const sectionFlowContent = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": `This type of person is grounded in feelings and meaning, valuing inner experiences and simply "being" over outward actions and achievements.`,
      "HEART TO MIND": "The Heart-to-Mind person feels first and thinks second. They start by caring, then add understanding to what's already unfolding. Once they feel grounded, they begin to strategize. Though much of this process happens within, they always bring it back to relationships, where they can openly explore and refine their ideas.",
      "HEART TO STRENGTH": "The Heart-to-Strength person is fueled by emotional energy and a focus on action. They're naturally driven by their feelings, wants, and needs, which motivate them to get things done.",
      "MIND TO HEART": "The Mind-to-Heart shift moves from logic to emotional connection, from head to heart.",
      "MIND TO SOUL": "People on the Mind-to-Soul path start with a clear plan and gradually seek deeper meaning, aiming to fit their ideas into a bigger, more meaningful picture.",
      "MIND TO STRENGTH": "People moving from Mind to Strength blend clear thinking with action. They're the \"think smarter, work harder\" type, constantly tweaking their strategies to get better results.",
      "SOUL TO HEART": "Soul-to-Heart individuals prioritize presence, relational depth, and meaningful connections. With an innate ability to connect emotionally, they inspire trust and loyalty through their genuine, authentic nature. They navigate life thoughtfully, seeing beyond the surface.",
      "SOUL TO MIND": "These people begin with depth, meaning, and vision, creating ideas to bring their insights to life. They organize and structure their inner world, and if they need a new structure, they'll invent it.",
      "SOUL TO STRENGTH": "Soul-to-Strength individuals quickly turn deep insights into action. They skip long planning phases, bringing the soul's depth straight into real-world impact.",
      "STRENGTH TO HEART": "Strength-to-Heart individuals dive into their missions with enthusiasm and passion, often bringing a welcoming attitude that quickly draws others in.",
      "STRENGTH TO MIND": "Strength-to-Mind individuals are fueled by action and a constant urge to make things better, always asking, \"How can this improve?\" This relentless drive for progress helps them advance quickly and find success.",
      "STRENGTH TO SOUL": "Strength-to-Soul individuals are dynamic visionaries who seek deeper meaning in their work, beyond just hitting goals.",
    };

    return contentMap[flowText] || "";
  };

  const flowTagline = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Feels good. But why?",
      "HEART TO MIND": "Feels good; I need to understand.",
      "HEART TO STRENGTH": "Feels good. Let's go!",
      "MIND TO HEART": "Makes sense, who do I need? ",
      "MIND TO SOUL": "Makes sense, but why?",
      "MIND TO STRENGTH": "Makes sense; let's go!",
      "SOUL TO HEART": "This is meaningful; let's feel it.",
      "SOUL TO MIND": "This is meaningful; let's design it.",
      "SOUL TO STRENGTH": "This is meaningful; let's do something.",
      "STRENGTH TO HEART": "I'm doing this. Who's in?",
      "STRENGTH TO MIND": "I'm doing this. How can it be better?",
      "STRENGTH TO SOUL": "I'm doing this, but why?",
    };

    return contentMap[flowText] || "";
  }

  const paraOne = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Heart-to-Soul individuals are guided by identity, values, and purpose. Rather than leading from the front, they create environments where life, love, and leadership can flourish naturally.",
      "HEART TO MIND": "This personality combines emotional connection with intellectual insight, creating a style that's both compassionate and strategically strong.",
      "HEART TO STRENGTH": "For them, shifting from heart to strength means moving from simply \"being\" to actively \"doing\"—from experiencing and connecting to making things happen in a tangible, practical way.",
      "SOUL TO MIND": "However, their carefully crafted plans can sometimes be hard to put into practice because they're based on big ideas and philosophy.",
      "MIND TO HEART": "These individuals, especially if relationally focused, prefer thoughtful and inclusive approaches over taking control. They need a deep understanding before they can fully invest or invite others in.",
      "MIND TO SOUL": "They commit to projects that match both their logical thinking and personal values, making their work both effective and fulfilling.",
      "MIND TO STRENGTH": "Focused on practical information and efficiency, they may sometimes overlook creativity, curiosity, or others' needs.",
      "SOUL TO HEART": "However, they may struggle in environments that value speed, competition, and strategy over depth and authenticity.",
      "SOUL TO STRENGTH": "Even without strong strategic or relational backing, their drive and commitment often lead to impressive, unexpected results.",
      "STRENGTH TO HEART": "They're natural motivators, using confidence, directness, and genuine empathy to kick-start projects and keep them going through emotional connection.",
      "STRENGTH TO MIND": "With a sharp focus on strategy and results, they sometimes overlook the emotional or cultural side of things, leaning toward efficiency over deeper relationships or cultural awareness. While they excel at getting things done, they may miss the nuances that create a more connected, balanced environment.",
      "STRENGTH TO SOUL": "They aim for their efforts to carry real significance, aligning personal values with professional goals. This means balancing practical actions with bigger visions to make their ideas a reality.",
    };

    return contentMap[flowText] || "";
  }

  const paraTwo = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Often seen as poets or creatives, they focus on soulful, intangible influence rather than conventional, straightforward strategies.",
      "HEART TO MIND": "",
      "HEART TO STRENGTH": "",
      "SOUL TO MIND": "",
      "MIND TO HEART": "Their clear thinking often brings calm to those seeking direction. Once they have a solid plan, they're ready to welcome others on board.",
      "MIND TO SOUL": "However, they may have many ideas and insights without taking much action, which can make them appear insightful but hard to pin down.",
      "MIND TO STRENGTH": "Mind-to-Strength individuals are direct, preferring to explain or show their ideas clearly, making them easy to understand.",
      "SOUL TO HEART": "",
      "SOUL TO STRENGTH": "",
      "STRENGTH TO HEART": "Their strong drive builds initial connections, but these relationships can be tested if goals or plans change. If others aren't aligned with their direction, they may be left behind.",
      "STRENGTH TO MIND": "",
      "STRENGTH TO SOUL": "Their high standards and shift toward purpose-driven goals can sometimes confuse or distance teammates used to simpler, more direct tasks. But despite these challenges, Strength-to-Soul people inspire others by showing how work can be both successful and deeply meaningful.",
    };

    return contentMap[flowText] || "";
  }

  const ArchtypeOne = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Deep Connector",
      "HEART TO MIND": "Collaborative Planner",
      "HEART TO STRENGTH": "Motivational Trailblazer",
      "SOUL TO MIND": "Purpose-Driven Innovator",
      "MIND TO HEART": "Strategic Connector",
      "MIND TO SOUL": "Philosophical Thinker",
      "MIND TO STRENGTH": "Continuous Improver",
      "SOUL TO HEART": "Authentic Guide",
      "SOUL TO STRENGTH": "Impactful Creator",
      "STRENGTH TO HEART": "Trusted Champion",
      "STRENGTH TO MIND": "Proactive Planner",
      "STRENGTH TO SOUL": "Genuine Influencer",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeTwo = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Grounded Guide",
      "HEART TO MIND": "Empathetic Guide",
      "HEART TO STRENGTH": "Passionate Doer",
      "SOUL TO MIND": "Visionary Architect",
      "MIND TO HEART": "Supportive Advisor",
      "MIND TO SOUL": "Insightful Innovator",
      "MIND TO STRENGTH": "Quick Problem-Solver",
      "SOUL TO HEART": "Compassionate Mentor",
      "SOUL TO STRENGTH": "Change Catalyst",
      "STRENGTH TO HEART": "Passionate Pioneer",
      "STRENGTH TO MIND": "Resourceful Thinker",
      "STRENGTH TO SOUL": "Resourceful Sage",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeThree = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Qualitative Advocate",
      "HEART TO MIND": "Culture Builder",
      "HEART TO STRENGTH": "Team Energizer",
      "SOUL TO MIND": "Thoughtful Communicator",
      "MIND TO HEART": "Compassionate Guide",
      "MIND TO SOUL": "Purpose-Driven Leader",
      "MIND TO STRENGTH": "Analytical Achiever",
      "SOUL TO HEART": "Relational Builder",
      "SOUL TO STRENGTH": "Driven Innovator",
      "STRENGTH TO HEART": "Community Builder",
      "STRENGTH TO MIND": "Considerate Driver",
      "STRENGTH TO SOUL": "Practical Mentor",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeFour = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Impractical Feeler",
      "HEART TO MIND": "Passive Strategist",
      "HEART TO STRENGTH": "Impulsive Drivers",
      "SOUL TO MIND": "Detached Idealist",
      "MIND TO HEART": "Oversensitive Analyst",
      "MIND TO SOUL": "Elusive Partner",
      "MIND TO STRENGTH": "Over-Analyzer",
      "SOUL TO HEART": "Disengaged Feeler",
      "SOUL TO STRENGTH": "Lone Wolf",
      "STRENGTH TO HEART": "Impulsive Reactor",
      "STRENGTH TO MIND": "Cold Pragmatist",
      "STRENGTH TO SOUL": "Detached Warrior",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeFive = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Complicated Connector",
      "HEART TO MIND": "Avoidant Decision-Maker",
      "HEART TO STRENGTH": "Short-sighted Steamroller",
      "SOUL TO MIND": "Big-Idea Drifter",
      "MIND TO HEART": "Burdened Planner",
      "MIND TO SOUL": "Idealistic Drifter",
      "MIND TO STRENGTH": "Lone Ranger",
      "SOUL TO HEART": "Over-absorbed Empath",
      "SOUL TO STRENGTH": "Isolated Visionary",
      "STRENGTH TO HEART": "Erratic Enthusiast",
      "STRENGTH TO MIND": "Stubborn Individualist",
      "STRENGTH TO SOUL": "Forceful Idealist",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeSix = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Idealistic Dreamer",
      "HEART TO MIND": "Over-functioning Caretaker",
      "HEART TO STRENGTH": "Emotional Time-bomb",
      "SOUL TO MIND": "Cold Philosopher",
      "MIND TO HEART": "Reluctant Engager",
      "MIND TO SOUL": "Quiet Idealist",
      "MIND TO STRENGTH": "Rigid Enforcer",
      "SOUL TO HEART": "Low-Assertive Idealist",
      "SOUL TO STRENGTH": "Idealistic Pioneer",
      "STRENGTH TO HEART": "Coercive Connector",
      "STRENGTH TO MIND": "Relentless Taskmaster",
      "STRENGTH TO SOUL": "Pessimistic Dreamer",
    };

    return contentMap[flowText] || "";
  }

  const imagesMap = {
    Soul: { icon: SoulIcon, label: "Soul" },
    Heart: { icon: HeartIcon, label: "Heart" },
    Mind: { icon: MindIcon, label: "Mind" },
    Strength: { icon: StrengthIcon, label: "Strength" },
  };
  const sortedScores = applyFullTieOrder([...scoreRanking].sort((a, b) => b.value - a.value));

  const sortedImages = sortedScores.map(item => imagesMap[item.name]);


  const sortedAndRoundedArray = [...snapshotResult]
    .sort((a, b) => b - a)
    .map(value => { const num = typeof value === 'number' ? value : parseFloat(value); return parseFloat(num.toFixed(2)); });

  const baseSize = 88;
  const sizeDecrement = 30;
  const sizeSequence = [88, 64, 50, 28];
  const minSize = sizeSequence[sizeSequence.length - 1];
  const imageSizes = sortedImages.map((_, index) =>
    sizeSequence[index] || Math.max(minSize, baseSize - index * sizeDecrement)
  );
  const itemWidth = Math.max(...imageSizes) + 20;

  const Arrow = () => (
    <svg width="70" height="28" viewBox="0 0 70 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
      <line x1="0" y1="12" x2="70" y2="12" stroke="#245775" strokeWidth="3.6" />
      <path d="M30 3L40 12L30 21" fill="none" stroke="#245775" strokeWidth="3.6" />
    </svg>

  );

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div className="heart-to-soul-container">
        <div className="header-section" style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
          <img src={getFlowImage()} alt="Heart to Soul Flow" style={{ width: '108px', height: '108px' }} />
          <div className="text-content">
            <h2 style={{
              fontFamily: 'Helvetica',
              fontWeight: 700,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              textTransform: 'uppercase',
              color: '#000000',
              margin: 0,
              paddingBottom: "5px",
            }}>YOU FLOW FROM {getFlowHead()}</h2>
            <p style={{
              fontFamily: 'Helvetica',
              fontWeight: 700,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: 0,
              paddingBottom: "5px",
            }}>{flowTagline(getFlowHead())}</p>
            <h3 style={{
              fontFamily: 'Helvetica',
              fontWeight: 700,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: 0,
              paddingBottom: "5px",
              textTransform: "uppercase",
            }}>Possible Archetypes</h3>
            <div style={{
              display: 'flex',
              gap: '32px'
            }}>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                fontFamily: 'Helvetica',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '10px',
                lineHeight: '14px',
                letterSpacing: '0px',
                color: '#000000'
              }}>
                <li style={{ paddingBottom: "4px" }}>• {ArchtypeOne(getFlowHead())}</li>
                <li style={{ paddingBottom: "4px" }}>• {ArchtypeTwo(getFlowHead())}</li>
                <li style={{ paddingBottom: "4px" }}>• {ArchtypeThree(getFlowHead())}</li>
              </ul>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                fontFamily: 'Helvetica',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '10px',
                lineHeight: '14px',
                letterSpacing: '0px',
                color: '#000000'
              }}>
                <li style={{ paddingBottom: "4px" }}>• {ArchtypeFour(getFlowHead())}</li>
                <li style={{ paddingBottom: "4px" }}>• {ArchtypeFive(getFlowHead())}</li>
                <li style={{ paddingBottom: "4px" }}>• {ArchtypeSix(getFlowHead())}</li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{
          fontSize: '10px',
          fontWeight: 400,
          color: '#000000',
          fontFamily: 'Helvetica',
          lineHeight: '14px',
          position: 'relative',
        }}>
          {sectionFlowContent(getFlowHead())}
          <br /><br />
          {paraOne(getFlowHead())}
          {paraTwo(getFlowHead()) && (
            <>
              <br /><br />
              {paraTwo(getFlowHead())}
            </>
          )}
        </div>

        <div style={{ width: '100%', marginTop: "34px" }}>
          <div style={{
            position: "relative",
            paddingTop: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "411px",
            margin: "0px auto"
          }}>
            <p style={{
              position: "absolute",
              left: "10%",
              transform: "translateX(-50%)",
              top: "0",
              fontSize: '10px',
              fontWeight: 700,
              color: '#245775',
              fontFamily: 'Helvetica',
              margin: 0,
              marginBottom: '8px'
            }}>Start</p>
            <div style={{
              width: "100%",
              maxWidth: "411px",
              display: 'flex',
              flexDirection: "row",
              gap: "57px",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {sortedImages.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  width: `${itemWidth}px`,
                  // width: index === sortedImages.length - 1 ? `${imageSizes[index]}px` : `${imageSizes[index] + 140}px`
                }}>
                  <img
                    src={item.icon}
                    alt={item.label}
                    style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex: "999" }}
                  />

                  {index < sortedImages.length - 1 && (
                    <div style={{
                      position: "absolute",
                      top: `${imageSizes[index] / 2}px`,
                      left: index === 0
                        ? "87px"
                        : index === 1
                          ? "62.5px"
                          : index === 2
                            ? "49px"
                            : "0px",
                      width: index == 2
                        ? "82px" : "74px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{
                        position: "absolute",
                        fontSize: 50,
                        fontWeight: 300,
                        top: -30,
                        left: 0,
                        color: "#245775",
                        fontFamily: 'Helvetica'
                      }}>
                        <Arrow />
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div style={{
              width: "100%",
              display: 'flex',
              flexDirection: "row",
              gap: "60px",
              alignItems: "center",
              justifyContent: "start"
            }}>
              {sortedImages.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  width: `${imageSizes[index]}px`,
                }}>
                  <div style={{
                    marginTop: '8px',
                    textAlign: 'center',
                    width: `${imageSizes[index]}px`,
                    minWidth: "fit-content",
                  }}>
                    <p style={{
                      margin: 0,
                      lineHeight: '14px',
                      fontWeight: 700,
                      fontSize: '10px',
                      color: '#245775',
                      fontFamily: 'Helvetica'
                    }}>{item.label}</p>
                    <p style={{
                      margin: 0,
                      fontSize: '10px',
                      color: '#5795B2',
                      fontWeight: 400,
                      textAlign: 'center',
                      lineHeight: '14px',
                      fontFamily: 'Helvetica, sans-serif',
                      whiteSpace: 'nowrap',
                      letterSpacing: 'normal'
                    }}>{typeof sortedScores[index].value === 'number' ? parseFloat(sortedScores[index].value)?.toFixed(2) : parseFloat(sortedScores[index].value).toFixed(2)}%</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
}

export default HeartToSoul;
